import axios from "axios";
import { ValidationError } from "../utils/Validations";

const baseURL = process.env.REACT_APP_ATHENA_BASE_URL;
const api = axios.create({ baseURL });

export interface MktWebWhatsappLeadRequest {
    name: string,
    email: string,
    phone: string,
    consents: string[],
    pageUrl?: string,
    googleReCaptchaToken?: string
    sellerName: string,
    title: string,
    attendanceType: string,
    clientId?: string
}

export interface MktWebWhatsappLeadResponse {
    success: boolean,
    payload?: string
}

export const sendWhatsappLead = async (request: MktWebWhatsappLeadRequest, path: string): Promise<MktWebWhatsappLeadResponse> => {
    try {
        const response = await api.post<MktWebWhatsappLeadResponse>('/form/' + path, request);
        return response.data;
    } catch (e: any) {
        if (e?.response?.data === 'Email inválido.') {
            throw new ValidationError('Email inválido');
        }
        throw e;
    }
}

export const getNextWhatsappPhone = async (request: MktWebWhatsappLeadRequest): Promise<MktWebWhatsappLeadResponse> => {
    return (await api.post<MktWebWhatsappLeadResponse>('/lead-api/lead/whatsapp?has-lead=false', request)).data;
}